import { LiksTextFormField } from '../../components/liks/LiksTextFormField/LiksTextFormField';
import { useI18n } from '../../i18n/useI18n';

type CreateLacUserDialogRequiredFieldsProps = {
  email: string;
  onEmailChange: (value: string) => void;
  isEmailInvalid: boolean;
  username: string;
  onUsernameChange: (value: string) => void;
  isUsernameInvalid: boolean;
  firstName: string;
  onFirstNameChange: (value: string) => void;
  lastName: string;
  onLastNameChange: (value: string) => void;
  sendInviteEmailFieldId: string;
  sendInviteEmail: boolean;
  onSendInviteEmailChange: (checked: boolean) => void;
  emailAutoFocus: boolean;
  isSubmitting: boolean;
};

export function CreateLacUserDialogRequiredFields({
  email,
  onEmailChange,
  isEmailInvalid,
  username,
  onUsernameChange,
  isUsernameInvalid,
  firstName,
  onFirstNameChange,
  lastName,
  onLastNameChange,
  sendInviteEmailFieldId,
  sendInviteEmail,
  onSendInviteEmailChange,
  emailAutoFocus,
  isSubmitting,
}: CreateLacUserDialogRequiredFieldsProps) {
  const { translate } = useI18n();

  return (
    <>
      <div className="lac-create-user__row">
        <LiksTextFormField
          label={translate('lac.users.create.emailLabel')}
          required
          type="email"
          value={email}
          onChange={onEmailChange}
          autoFocus={emailAutoFocus}
          disabled={isSubmitting}
          autoComplete="off"
          error={
            isEmailInvalid ? translate('lac.users.create.emailInvalid') : null
          }
        />

        <LiksTextFormField
          label={translate('lac.users.create.usernameLabel')}
          required
          value={username}
          onChange={onUsernameChange}
          disabled={isSubmitting}
          autoComplete="off"
          error={
            isUsernameInvalid
              ? translate('lac.users.create.usernameNoSpaces')
              : null
          }
        />
      </div>

      <div className="lac-create-user__row">
        <LiksTextFormField
          label={translate('lac.users.create.firstNameLabel')}
          required
          value={firstName}
          onChange={onFirstNameChange}
          disabled={isSubmitting}
          autoComplete="off"
        />

        <LiksTextFormField
          label={translate('lac.users.create.lastNameLabel')}
          required
          value={lastName}
          onChange={onLastNameChange}
          disabled={isSubmitting}
          autoComplete="off"
        />
      </div>

      <label
        className="lac-create-user__checkbox"
        htmlFor={sendInviteEmailFieldId}
      >
        <input
          id={sendInviteEmailFieldId}
          type="checkbox"
          checked={sendInviteEmail}
          onChange={(event) => onSendInviteEmailChange(event.target.checked)}
          disabled={isSubmitting}
        />
        <span>{translate('lac.users.create.sendInviteEmailLabel')}</span>
      </label>
    </>
  );
}
